<div *ngIf="availableMetrics.length === 0;else createForm" class="d-flex justify-content-center align-items-center h-100">
    <div>
        <img src="../App_Themes/CXone/images/no-metric-defined.svg" alt="No metric defined" class="no-metric-image">
        <div class="d-flex flex-column justify-content-center">
            <p class="no-metric-text" cvLocalizedText langSection="Challenges" langKey="No_Metric_Defined">No metric defined for the challenge.</p>
            <p class="no-metric-text" cvLocalizedText langSection="Challenges" langKey="No_Metric_Contact">Please contact your manager.</p>
        </div>
    </div>
</div>
<ng-template #createForm>
    <div class="challenge-container" [formGroup]="challengeForm">
        <div class="input-container">
            <sol-dropdown [label]="getTranslation('Metric', 'Metric')" [isMultiple]="false" name="metric"
                [placeholder]="getTranslation('Select_Metric', 'Select metric')" formControlName="metric" [options]="metric"
                [ngClass]="{'input-error': displayError(challengeForm.controls['metric'])}"></sol-dropdown>
        </div>
        <div class="input-container">
            <sol-radio-group [groupLabel]="getTranslation('Schedule_Label', 'Schedule')" [inline]="true"
                formControlName="schedule">
                <sol-radio-button value="Daily">1 <span cvLocalizedText langSection="Challenges"
                        langKey="Schedule_Interval_Day">Day</span></sol-radio-button>
                <sol-radio-button value="Weekly"> 1 <span cvLocalizedText langSection="Challenges"
                        langKey="Schedule_Interval_Week">Week</span></sol-radio-button>
            </sol-radio-group>
        </div>
        <div class="input-container">
            <sol-dropdown [label]="getTranslation('Invite_Participant', 'Invite Participant')" [isMultiple]="true"
                name="inviteParticipant" [searchEnabled]="true" [disabled]="participants.length === 0"
                [placeholder]="getTranslation('Invite_Participant_Placeholder', 'Select participant')"
                formControlName="inviteParticipant" [options]="participants"></sol-dropdown>
        </div>
        <div class="input-container">
            <sol-datepicker format="MMM d, y" [showActionArrows]="false" inputText="Start Date" [disabled]="participants.length === 0"
                formControlName="startDate" [min]="minDate" [daysDisabled]="disabledDates" (ngModelChange)="onDateChange($event)"></sol-datepicker>
        </div>
        <div class="input-container">
            <span class="title-selector" cvLocalizedText langSection="Challenges" langKey="Wager_Coins_Uppercase">WAGER COINS</span>
            <div class="d-flex align-items-center">
                <cxone-text-input id="cxone-input-wager"
                    [ngClass]="{'no-error': challengeForm.controls['wagerAmount'].hasError('required') || challengeForm.controls['wagerAmount'].hasError('pattern')}"
                    formControlName="wagerAmount"
                    cvInputNumericFormat
                    type="text"
                    class="text-input wager-input"
                    placeholder=""
                    [maxCharLength]="13"
                    name="wagerAmount"
                    (keyup)="validateWagerInput($event, challengeForm.controls['wagerAmount'])"
                    (paste)="validateClipboardInput($event, challengeForm.controls['wagerAmount'])"></cxone-text-input>
                <span class="coins-selector" cvLocalizedText langSection="Challenges_Create" langKey="Coins">Coins</span>
            </div>
            <span class="error-label" [ngClass]="{'error-color': displayError(challengeForm.controls['wagerAmount']) && !(challengeForm.controls['wagerAmount'].hasError('required') || challengeForm.controls['wagerAmount'].hasError('pattern'))}"><span
                    cvLocalizedText langSection="Challenges" langKey="Available_Coins">Available coins</span>
                <span>{{" "}}</span>
                <span>{{availableCoins | cvNumberLocalize}}</span></span>
        </div>
    </div>
</ng-template>